import { Layout, Button, Dropdown, Avatar, Space, theme } from 'antd';
import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  UserOutlined,
  LogoutOutlined,
} from '@ant-design/icons';
import { Sun, Moon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useUIStore } from '@/stores/ui.store';
import { useAuthStore } from '@/stores/auth.store';
import { ROUTES } from '@/lib/constants/routes';
import { usePresignedImageUrl } from '@/hooks/usePresignedImageUrl';

export function Header() {
  const navigate = useNavigate();
  const { sidebarCollapsed, toggleSidebar, themeMode, toggleTheme } = useUIStore();
  const { admin, logout } = useAuthStore();
  const { token } = theme.useToken();
  const { data: photoData } = usePresignedImageUrl(admin?.profilePhotoUrl);
  const handleLogout = () => {
    logout();
    navigate(ROUTES.LOGIN);
  };

  const dropdownItems = {
    items: [
      {
        key: 'profile',
        icon: <UserOutlined />,
        label: 'My Profile',
        onClick: () => navigate(ROUTES.PROFILE),
      },
      { type: 'divider' as const },
      {
        key: 'logout',
        icon: <LogoutOutlined />,
        label: 'Logout',
        danger: true,
        onClick: handleLogout,
      },
    ],
  };

  return (
    <Layout.Header
      style={{
        padding: '0 24px',
        background: token.colorBgContainer,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        borderBottom: `1px solid ${token.colorBorderSecondary}`,
      }}
    >
      <Button
        type="text"
        icon={sidebarCollapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
        onClick={toggleSidebar}
        style={{ fontSize: 16 }}
      />
      <Space size="middle">
        <Button
          type="text"
          icon={themeMode === 'dark' ? <Sun size={18} /> : <Moon size={18} />}
          onClick={toggleTheme}
        />
        <Dropdown menu={dropdownItems} placement="bottomRight">
          <Space style={{ cursor: 'pointer' }}>
            <Avatar icon={<UserOutlined />} src={photoData?.url} />
            <span>{admin?.name || 'Admin'}</span>
          </Space>
        </Dropdown>
      </Space>
    </Layout.Header>
  );
}
